<script>
export default {
  name: "CheckPlagiarism",
  props: {
    PLAGIARISM_RATE: {
      type: Array,
      default: () => []
    },
    plagiarismData: {
      type: Object,
      default: () => {
      }
    },
    haveBackButton:{
      type:Boolean,
      default:false
    }
  },
  methods: {
    nextStep() {
        if(+this.plagiarismData.plagiarismRate === 4 && this.plagiarismData.isPlagiarism){
          this.$emit('markPlagiarism')
          return
        }
        this.$emit('nextStep')

    },
    backStep(){
      this.$emit('backStep')
    }
  }
}
</script>

<template>
  <div style="background-color: #F8F8F8" class="rounded px-4 py-4 col-12">
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form @submit.prevent>
        <p style="font-size: 13px; font-weight: 400;color: #4F4F4F">Bài viết có dấu hiệu đạo văn không?</p>
        <el-radio v-model="plagiarismData.isPlagiarism" :label="false">Không</el-radio>
        <br>
        <el-radio v-model="plagiarismData.isPlagiarism" :label="true">Có</el-radio>
        <div v-if="plagiarismData.isPlagiarism">
          <hr>
          <div class="d-flex align-items-center">
            <p style="font-size: 13px; font-weight: 400;color: #4F4F4F" class="my-0 mr-3">Tỉ lệ đạo văn của bài viết
              <span style="color: red">*</span></p>
            <ValidationProvider name="Tỉ lệ đạo văn" rules="required" v-slot="{ errors,classes }"
                                vid="Tỉ lệ đạo văn">
              <el-select
                  v-model="plagiarismData.plagiarismRate"
                  placeholder="Chọn"
                  size="small"
                  style="width: 150px"
              >
                <el-option
                    v-for="item in PLAGIARISM_RATE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
              </el-select>
              <div class="fv-plugins-message-container">
                <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
          <div class="mt-6">
            <p style="font-size: 13px; font-weight: 400;color: #4F4F4F">Nhận xét cụ thể, dẫn chứng <span
                style="color: red">*</span></p>
            <ValidationProvider name="Nhận xét cụ thể" rules="required" v-slot="{ errors,classes }"
                                vid="Nhận xét cụ thể">
              <el-input
                  v-model="plagiarismData.plagiarismComment"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  type="textarea"
                  placeholder="Nhập nhận xét"
              />
              <div class="fv-plugins-message-container">
                <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button v-if="haveBackButton" type="button" class="btn btn-secondary mt-6 mr-4" @click="backStep()">Quay lại</button>
          <button type="button" class="btn btn-primary mt-6" @click="handleSubmit(nextStep)">Tiếp theo</button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<style scoped>

</style>